module.exports = __webpack_public_path__ + "media/assets/images/blog/TESTA-LINKEDIN-2.jpg-small-3f5d47738aa5dee96bb1e1f291467505.png";